import React, { useContext } from "react";
import { FirebaseContext } from "../../../FirebaseContext";
import { SelectionButton } from "../SelectionButton/";
import './SelectSpecies.css';
import aasimarIcon from '../../../Images/species/aasimar.png';
import dragonbornIcon from '../../../Images/species/dragonborn.png';
import dwarfIcon from '../../../Images/species/dwarf.png';
import elfIcon from '../../../Images/species/elf.png';
import gnomeIcon from '../../../Images/species/gnome.png';
import goliathIcon from '../../../Images/species/goliath.png';
import halflingIcon from '../../../Images/species/halfling.png';
import humanIcon from '../../../Images/species/human.png';
import orcIcon from '../../../Images/species/orc.png';
import tieflingIcon from '../../../Images/species/tiefling.png';
import smallSizeIcon from '../../../Images/other/size_small.webp';
import mediumSizeIcon from '../../../Images/other/size_medium.webp';

export const SelectSpecies = () => {
    const { characterJSON, setCharacterJSON } = useContext(FirebaseContext);

    const selectingSpecies = (speciesName) => {
        if (characterJSON.species === speciesName) {
            setCharacterJSON(prevState => ({
                ...prevState,
                species: '',
                size: '', // Reset size when changing species
                subspecies: '' // Reset subspecies when changing species
            }));
        } else {
            setCharacterJSON(prevState => ({
                ...prevState,
                species: speciesName,
                size: '', // Reset size when changing species
                subspecies: '' // Reset subspecies when changing species
            }));
        }
    };

    const selectingSubspecies = (subspeciesName) => {
        if (characterJSON.subspecies === subspeciesName) {
            setCharacterJSON(prevState => ({
                ...prevState,
                subspecies: ''
            }));
        } else {
            setCharacterJSON(prevState => ({
                ...prevState,
                subspecies: subspeciesName
            }));
        }
    };

    const selectingSize = (size) => {
        if (characterJSON.size === size) {
            setCharacterJSON(prevState => ({
                ...prevState,
                size: ''
            }));
        } else {
            setCharacterJSON(prevState => ({
                ...prevState,
                size: size
            }));
        }
    };

    const species = [
        { name: 'Aasimar', icon: aasimarIcon, disabled: false },
        { name: 'Dragonborn', icon: dragonbornIcon, disabled: false },
        { name: 'Dwarf', icon: dwarfIcon, disabled: false },
        { name: 'Elf', icon: elfIcon, disabled: false },
        { name: 'Gnome', icon: gnomeIcon, disabled: false },
        { name: 'Goliath', icon: goliathIcon, disabled: false },
        { name: 'Halfling', icon: halflingIcon, disabled: false }, 
        { name: 'Human', icon: humanIcon, disabled: false },  
        { name: 'Orc', icon: orcIcon, disabled: false },
        { name: 'Tiefling', icon: tieflingIcon, disabled: false }
    ];    

    return (
        <div className="content-wrapper">
            <h2 className="character-heading">
                Choose a species:
            </h2>  
            <div className="character-grid">
                {species.map((charSpecies) => (
                    <SelectionButton
                        key={charSpecies.name}
                        name={charSpecies.name}
                        icon={charSpecies.icon}
                        isSelected={characterJSON.species === charSpecies.name}
                        onClick={() => selectingSpecies(charSpecies.name)}
                        disabled={charSpecies.disabled}
                    /> 
                ))}
            </div>

            {["Aasimar", "Human", "Tiefling"].includes(characterJSON.species) && (
                <>
                    <h2 className="character-heading">
                        Choose a size:
                    </h2>
                    <div className="character-grid">
                        {["Small", "Medium"].map((size) => {
                            const icon = size === "Small" ? smallSizeIcon : mediumSizeIcon;
                            return (
                                <SelectionButton
                                    key={`${size}Size`}
                                    name={size}
                                    icon={icon} // Using the specific icon based on size
                                    isSelected={characterJSON.size === size}
                                    onClick={() => selectingSize(size)}
                                />
                            );
                        })}
                    </div>
                </>            
            )}

            {characterJSON.species === "Dragonborn" && (
                <>
                    <h2 className="character-heading">
                        Choose a draconic ancestry:
                    </h2> 
                    <div className="character-grid">
                        {["Black", "Blue", "Brass", "Bronze", "Copper", "Gold", "Green", "Red", "Silver", "White"].map((subspecies) => (
                            <SelectionButton
                                key={`${subspecies}Subspecies`}
                                name={subspecies}
                                icon={dragonbornIcon}
                                isSelected={characterJSON.subspecies === subspecies}
                                onClick={() => selectingSubspecies(subspecies)}
                            />
                        ))}
                    </div>
                </>
            )}

            {characterJSON.species === "Elf" && (
                <>
                    <h2 className="character-heading">
                        Choose an elven lineage:
                    </h2>
                    <div className="character-grid">
                        {["Drow", "High Elf", "Wood Elf"].map((subspecies) => (
                            <SelectionButton
                                key={`${subspecies}Subspecies`}
                                name={subspecies}
                                icon={elfIcon}
                                isSelected={characterJSON.subspecies === subspecies}
                                onClick={() => selectingSubspecies(subspecies)}
                            />
                        ))}
                    </div>
                </>
            )}

            {characterJSON.species === "Gnome" && (
                <>
                    <h2 className="character-heading">
                        Choose a gnomish lineage:
                    </h2>
                    <div className="character-grid">
                        {["Forest Gnome", "Rock Gnome"].map((subspecies) => (
                            <SelectionButton
                                key={`${subspecies}Subspecies`}
                                name={subspecies}
                                icon={gnomeIcon}
                                isSelected={characterJSON.subspecies === subspecies}
                                onClick={() => selectingSubspecies(subspecies)}
                            />
                        ))}
                    </div>
                </>
            )}

            {characterJSON.species === "Goliath" && (
                <>
                    <h2 className="character-heading">
                        Choose a giant ancestry:
                    </h2>
                    <div className="character-grid">
                        {["Cloud", "Fire", "Frost", "Hill", "Stone", "Storm"].map((subspecies) => (
                            <SelectionButton
                                key={`${subspecies}Subspecies`}
                                name={subspecies}
                                icon={goliathIcon}
                                isSelected={characterJSON.subspecies === subspecies}
                                onClick={() => selectingSubspecies(subspecies)}
                            />
                        ))}
                    </div>
                </>
            )}

            {characterJSON.species === "Tiefling" && (
                <>
                    <h2 className="character-heading">
                        Choose a fiendish legacy:
                    </h2>
                    <div className="character-grid">
                        {["Abyssal", "Chthonic", "Infernal"].map((subspecies) => (
                            <SelectionButton
                                key={`${subspecies}Subspecies`}
                                name={subspecies}
                                icon={tieflingIcon}
                                isSelected={characterJSON.subspecies === subspecies}
                                onClick={() => selectingSubspecies(subspecies)}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
